import { Heart } from '@finect/tabular-icons/heart';
import { Eye } from '@finect/tabular-icons/eye';
import { BarChart } from '@finect/tabular-icons/barChart';
import { Briefcase } from '@finect/tabular-icons/briefcase';
export var shortcuts = [{
  id: 'subscriptions',
  value: 'Mis favoritos',
  icon: Heart
}, {
  id: 'lastViewed',
  value: 'Mis vistos',
  icon: Eye
}, {
  id: 'mostViewed',
  value: 'Más vistos',
  icon: BarChart
}, {
  id: 'sameManagementCompany',
  value: 'Gestora',
  icon: Briefcase,
  condition: function condition(_ref) {
    var initialProduct = _ref.initialProduct;
    return initialProduct && initialProduct.managementCompany;
  }
}];